/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoanInfoService {
  constructor(private http: HttpClient) {}
  loanInfo: Subject<any> = new Subject<any>();
  loanInfo$: Observable<any> = this.loanInfo.asObservable();
}
